jQuery(function ($) {
    /**
     * @description Get shop Js variables
     */
    function getShopData() {
        const isCheckoutPage = VetfondsJs.vetShopData.isCheckoutPage;
        let siteUrl = VetfondsJs.vetShopData.siteUrl;
        let restUrl = '/wp-json/vetfonds/v1/get-shop-data';

        $.ajax({
            type: 'get',
            url: siteUrl + restUrl,
            beforeSend: function (response) {

            },
            complete: function (response) {

            },
            success: function (response) {
                updateShopData(response);

            },
        });

        if (isCheckoutPage) {
            //location.reload();
        }
    }

    /**
     * description update VetfondsJs variables
     * @param data
     */
    function updateShopData(data) {
        if (data) {
            VetfondsJs.vetShopData.minOrderPrice = data.minOrderPrice;
            //VetfondsJs.vetShopData.cartTotalPrice = data.cartTotalPrice;
            //VetfondsJs.vetShopData.beforeCanBuy = data.beforeCanBuy;
        }
    }
});